import urls from "./config.json";

const config = () => {
  if (window.location.href.includes("portaldev.unrealsoft.bg")) {
    return urls.DEVELOPMENT;
  }
  if (window.location.href.includes("happysportal.unrealsoft.bg")) {
    return urls.STAGE_HAPPY;
  }
  if (window.location.href.includes("happyportal.unrealsoft.bg")) {
    return urls.PRODUCTION_HAPPY;
  }
  if (window.location.href.includes("portal.unrealsoft.bg")) {
    return urls.PRODUCTION;
  }

  return urls.LOCAL;
};

export const apiURl = config();
